/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from "react";
import { DEBUG } from "../settings";
import { errorLogger } from "../utils/logger";

/**
 * エラーを監視してエラーが発生したらエラーページに飛ばす
 * @param observingError 監視するApolloErrorもしくはstring
 * @param hookDeps エラーがあればエラーページに飛ばす処理をhookさせるdependencies
 * @return handleError エラーページに飛ばす処理を発生させる関数
 */
export const useHandleError = (
  observingError: Error | undefined | string = undefined,
  hookDeps: any[] = [],
) => {
  // TODO: ApolloErrorはerrorLinkに任せることにしたのでuseHandleErrorにApolloErrorを渡している箇所をなくすように修正する
  const handleError = (errorMessage?: unknown) => {
    if (DEBUG === "*" && errorMessage !== undefined) {
      errorLogger(`${errorMessage}`);
    }
  };

  useEffect(() => {
    if (observingError) {
      handleError();
    }
  }, [observingError, ...hookDeps]);

  return { handleError };
};
